import React from 'react';

import '../styles/app.scss';
import {
  BrowserRouter, Route, NavLink, Switch, Redirect,
} from 'react-router-dom';
import Bio from './bio';
import ProjectPage, { ProjectIndex } from './projects';
import Questions from './questions';
import Facts from './facts';

// Path prefix this site is mounted at, on nathanbuilds.dev and in dev alike.
// Must match `output.publicPath` in webpack.config.js and the site's prefix in
// the edge routing table (playground/26/nathanbuilds-edge/lib/sites.ts).
export const BASENAME = '/about';

const Nav = () => {
  return (
    <div className="navbar">
      <li><NavLink exact to="/">About</NavLink></li>
      <li><NavLink to="/projects">Projects</NavLink></li>
      {/* <li><NavLink to="/questions">Q/A</NavLink></li> */}

    </div>
  );
};

const FallBack = () => {
  return <div>URL Not Found</div>;
};

const App = (props) => {
  return (
    // The site is served under nathanbuilds.dev/about/ so the domain root can
    // route to several projects by path. basename keeps every <NavLink to="/x">
    // below writing real URLs like /about/x — CloudFront rewrites those back to
    // this app shell, so they deep-link and reload correctly.
    <BrowserRouter basename={BASENAME}>
      <div>
        <Nav />
        <Switch>
          <Route exact path="/" component={Bio} />
          <Route exact path="/projects" component={ProjectIndex} />
          <Route exact path="/projects/:slug" component={ProjectPage} />
          <Route exact path="/questions" component={Questions} />
          <Route exact path="/facts" component={Facts} />
          {/* Old standalone writeup paths, still linked from elsewhere. */}
          <Redirect exact from="/valorant" to="/projects/valorant" />
          <Redirect exact from="/engs21" to="/projects/engs21" />

          <Route component={FallBack} />
        </Switch>
      </div>
    </BrowserRouter>
  );
};

export default App;
